import { render, staticRenderFns } from "./BannerNotification.vue?vue&type=template&id=750316bb&scoped=true"
import script from "./BannerNotification.vue?vue&type=script&lang=js"
export * from "./BannerNotification.vue?vue&type=script&lang=js"
import style0 from "./BannerNotification.vue?vue&type=style&index=0&id=750316bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750316bb",
  null
  
)

export default component.exports